import React, { createRef, RefObject } from "react"
import { Script } from "./Script";

const RECAPTCHA_SELECTOR = 'script[src^="https://www.gstatic.com/recaptcha/releases/"]';
const ARTIFACTS = ["FF_JSAPI", "ff-ui-datepicker-div"];

interface Props {
  src: string,
}

export class FormForSalesforceScript extends React.Component<Props> {
  componentDidMount() {
    // deleting this var from the window will allow subsequent script executions to load a form
    // @ts-ignore
    delete window.executeDefaultFormLoad;
  }

  componentWillUnmount() {
    // remove known artifacts of their script from the document
    for (const id of ARTIFACTS) {
      const el = document.getElementById(id);
      el?.parentNode?.removeChild(el);
    }

    // also their recaptcha
    const el = document.head.querySelector(RECAPTCHA_SELECTOR);
    if (el)
      document.head.removeChild(el);
  }

  render() {
    return <Script type="text/javascript" id="jsFastForms" src={this.props.src} />;
  }
}
